import { IntroScreenUIConfig } from "../../components/ui/intro-screen-ui";
import { SingleScenarioInfoConfig } from "../../components/ui/scenario-info-ui";
import GameManager from "../../cvp-webgames-core/GameManager";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { SingleVideoSegmentItem, VideoSegmentItem } from "../../cvp-webgames-core/VideoSegment/VideoSegmentItem";
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from "../../cvp-webgames-core/pre-caching/pre-cache-item";
import { getSaveData, PageType } from "../../misc/tools";
import { GameBaseScenario } from "../GameBaseScenario";
import BufferInMriComponentsStep0Component from "./components/buffer-in-mri-components-step0/buffer-in-mri-components-step0";
import BufferInMriComponentsStep0Part1 from "./components/buffer-in-mri-components-step0/buffer-in-mri-components-step0-parts/buffer-in-mri-components-step0-part1";
import BufferInMriComponentsStep1Component from "./components/buffer-in-mri-components-step1/buffer-in-mri-components-step1";
import BufferInMriComponentsStep1Part1 from "./components/buffer-in-mri-components-step1/buffer-in-mri-components-step1-parts/buffer-in-mri-components-step1-part1";
import BufferInMriComponentsStep2Component from "./components/buffer-in-mri-components-step2/buffer-in-mri-components-step2";
import BufferInMriComponentsStep2Part1 from "./components/buffer-in-mri-components-step2/buffer-in-mri-components-step2-parts/buffer-in-mri-components-step2-part1";

class Scenario5BufferInMriVideoSegments extends VideoSegmentItem {
	public get title(): string {
		return 'Scenario 5 Buffer In Mri';
    }
	public getItems(): SingleVideoSegmentItem[] {
		return [
			{
				key: 'Scenario 5 Video 1',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario05/sc05-cinematic/cin-sc-5.mp4',
				chapterIds: [
					'Chapter 1'
				]
			},
			{
				key: 'MixedMedia',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario05/sc05-mentor/mntr-sc-05.mp4', // change this
				chapterIds: [
					'step-2'// alan to update premiere file with audios lol at the end of the time code.
				]
			},
			{
				key: 'Feedback',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario05/sc05-mentor/mntr-sc-05.mp4', // change this 
				chapterIds: [
					'scenario5-3', //question 1 correct - don't delete comment!
					'scenario5-4', //question 1 incorrect - don't delete comment!
					'scenario5-5', //question 1 other option - don't delete comment!
					'scenario5-7',//question 2 correct - don't delete comment!
					'scenario5-8', //question 2 incorrect - don't delete comment!
					'scenario5-9', //question 2 other option - don't delete comment!
					'scenario5-12', //question 3 correct - don't delete comment!
					'scenario5-13', //question 3 incorrect - don't delete comment!
					'scenario5-17', //question 4 correct - don't delete comment!
					'scenario5-15', //question 4 incorrect - don't delete comment!
					'scenario5-16', //question 4 other option - don't delete comment!
					'scenario5-20', //question 5 correct - don't delete comment!
					'scenario5-19', //question 5 incorrect - don't delete comment!
					'scenario5-1', //scenario info 
					'scenario5-21' //scenario review 
				]
			}
		];
	}
}

export const scenario5BufferInMriVideoSegments = new Scenario5BufferInMriVideoSegments();

class Scenario5BufferInMriAudioCaching extends PreCacheItem {
    public audioKeys = {
        question1: 'question1',
        question2: 'question2',
        question3: 'question3',
        question4: 'question4',
        question5: 'question5'
    };
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question1,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-05/mentor/jcdst-mentor-vo-scn-05-05.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question2,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-05/mentor/jcdst-mentor-vo-scn-05-10.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question3,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-05/mentor/jcdst-mentor-vo-scn-05-16.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question4,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-05/mentor/jcdst-mentor-vo-scn-05-20.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question5,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-05/mentor/jcdst-mentor-vo-scn-05-25.mp3'
			}
		];
	}
}

export const scenario5BufferInMriAudioCaching = new Scenario5BufferInMriAudioCaching();

export default class Scenario5BufferInMri extends GameBaseScenario {
	public comp1Step1FirstSelectedChoiceIndex: number = -1;
	public getScenarioInfo(): SingleScenarioInfoConfig {
		return {
			scenarioId: PageType.Scenario5BufferInMri,
			title: 'Buffer in MRI',
			subtitle: 'Situation/Background',
			img: process.env.PUBLIC_URL + '/assets/images/scenarios/sample-image.png',
			description: `
				<p class="small-text" style="margin: 20px; text-align: center">
				After this learning activity you will be able to apply the Just Culture Decision Support Tool after an adverse event occurs.
				
				A floor buffer got stuck in the brand-new MRI unit. No one was available over the weekend 
				who knew how to operate the MRI machine. The nursing supervisor noticed the red “stop” button 
				and quenched the MRI machine. The result of the quench caused the MRI unit to be out of 
				order for several weeks and cost several thousands of dollars to repair.
				</p>
			`,
			mentorVideoUrl: scenario5BufferInMriVideoSegments.getItemByKey('Feedback').src,
			mentorChapterId: scenario5BufferInMriVideoSegments.getItemByKey('Feedback').chapterIds[13]
		}
    }
	public getMentorVideoURLs(): SingleVideoSegmentItem[] {
		return [
			scenario5BufferInMriVideoSegments.getItemByKey('MixedMedia'),
			scenario5BufferInMriVideoSegments.getItemByKey('Feedback'),
		] 
	}
	public resumeScenarioFromArea(areaIndx: number): void {
		switch(areaIndx) {
			case 0:
				(this.step0Component.parts[0] as BufferInMriComponentsStep0Part1).section2();
				break;
			case 1:
				(this.step0Component.parts[0] as BufferInMriComponentsStep0Part1).section3();
				break;
			case 2:
				(this.step1Component.parts[0] as BufferInMriComponentsStep1Part1).section2();
				break;
			case 3:
				(this.step1Component.parts[0] as BufferInMriComponentsStep1Part1).section3();
				break;
			case 4:
				(this.step2Component.parts[0] as BufferInMriComponentsStep2Part1).section1();
				break;
			case 5:
				(this.step2Component.parts[0] as BufferInMriComponentsStep2Part1).section2();
				break;
			case 6:
				(this.step1Component.parts[0] as BufferInMriComponentsStep1Part1).section1();
				break;
		}
	}

	//VALUES BELOW ARE FOR DEBUG PURPOSES IN CASE STEP 1 is SKIPPED
	// public comp1Step1FirstSelectedChoiceIndex: number = 0;
	public scenarioId(): PageType {
		return PageType.Scenario5BufferInMri;
    }

	private video: SingleVideoSegmentItem = scenario5BufferInMriVideoSegments.getItemByKey('Scenario 5 Video 1');
	public getScenarioVideoURL(): string {
		return this.video.src;
	}
	public introScreenInfo(): IntroScreenUIConfig {
		return {
		title: 'Buffer in MRI',
		subtitle: 'Incident Report',
		name: 'Mike',
		position: 'EMS Housekeeper',
		time: '4:45 pm',
		place: 'MRI Unit',
		desc: `A floor buffer got stuck in the brand-new MRI unit. No one was available over the weekend 
		who knew how to operate the MRI machine. The nursing supervisor noticed the red “stop” 
		button and quenched the MRI machine. The result of the quench caused the MRI unit to be 
		out of order for several weeks and several thousands of dollars to repair.`,
		repeat: 'No',
		okButton: 'Continue'
		}
	}

	private step0Component = new BufferInMriComponentsStep0Component({
		scenario: this,
		onDone: () => {
			this.goToStep1Component();
		}
	})

	private step1Component = new BufferInMriComponentsStep1Component({
		scenario: this,
		onDone: () => {
			this.goToStep2Component();
		}
	})

	private step2Component = new BufferInMriComponentsStep2Component({
		scenario: this,
		onDone: () => {
			this.uiWrapper.displayAAR();
		}
	})

	private parts: BaseScenarioPart<GameBaseScenario>[] = [].concat(this.step0Component.parts)
		.concat(this.step1Component.parts)
		.concat(this.step2Component.parts);

	constructor(gameManager: GameManager, scenarioName: string) {
		super(gameManager, scenarioName);
		this._setupStep0Component();
		this._setupStep1Component();
		this._setupStep2Component();
	}

	start() {
		this.goToStep0Component();
	}

	private _setupStep0Component() {
		this.step0Component.config.part1Config = {
			chapter: () => {
				return this.video.chapterIds[0];
			},
			videoUrl: this.video.src
		}
	}

	private _setupStep1Component() {
		this.step1Component.config.part1Config = {
			chapter: () => {
				return this.video.chapterIds[0];
			},
			videoUrl: this.video.src
		}
	}

	private _setupStep2Component() {
		this.step2Component.config.part1Config = {
			videoUrl: this.video.src
		}
	}

	public getParts(): BaseScenarioPart<GameBaseScenario>[] {
		return this.parts;
	}

	public getSoundPath(fileName: string): string {
		return process.env.PUBLIC_URL + '/assets/audio/scenario1/' + fileName + '.ogg';
	}

	goToStep0Component() {
		this.step0Component.start();
	}

	goToStep1Component() {
		this.step1Component.start();
	}

	goToStep2Component() {
		this.step2Component.start();
	}
}